
//Gère le téléchargement de fichier
export class TelechargementFichier 
{
  //Télécharge un fichier
  //  Paramètres
  //    nomFichier     : Nom du fichier
  //    donneesFichier : Données du fichier
  //    typeContenu    : Type de contenu
  public static Telecharger (nomFichier: string, donneesFichier: string, typeContenu: string) : void 
  {
    let blob: Blob;
    let objetUrl: string;
    let htmlAnchorElement: HTMLAnchorElement;
    
    blob = this.CreerBlob (donneesFichier, typeContenu);

    objetUrl = URL.createObjectURL (blob);

    htmlAnchorElement = document.createElement ("a");

    htmlAnchorElement.href = objetUrl;
    htmlAnchorElement.download = nomFichier;
    htmlAnchorElement.click ();

    URL.revokeObjectURL (objetUrl);
  }

  //Crée le blob du fichier
  //  Paramètres
  //    donneesFichier : Données du fichier
  //    typeContenu    : Type de contenu
  //  Retourne
  //    Blob fichier
  public static CreerBlob (donneesFichier: string, typeContenu: string) : Blob 
  {
    let blob: Blob;
    let caracteres: string;

    caracteres = atob (donneesFichier);

    const bytes = new Uint8Array (caracteres.length);

    for (let index = 0; index < caracteres.length; index++)
      bytes[index] = caracteres.charCodeAt (index);

    blob = new Blob ([bytes], {type: typeContenu});

    return blob;
  }
}